export default defineNuxtRouteMiddleware(async (currentRoute) => {  
  const backend = useBackend();
  const { getMetaTags } = backend;

  const { data: metaTags } = await getMetaTags(currentRoute.fullPath);

  const defaultTitle = "Vehis.pl - Atrakcyjny leasing samochodów nowych i używanych";
  const defaultDescription = "Leasing samochodów z atrakcyjnymi warunkami finansowania u lidera w branży ✔️ Decyzja w 15 min. Sprawdź!";

  const title = metaTags.title || defaultTitle;
  const description = metaTags.description || defaultDescription;
  useState('cmsPageMainHeader', () => metaTags.h1); // Store h1 in a state for page use

  useHead({
    title,
    meta: [
      { name: "description", content: description },
    ]
  });
});